var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Zm1 6H6v5h2V6Zm0-3H6v2h2V3Z",
  fill: "#5A687B",
  fillRule: "evenodd"
})));
export { SvgIcoInfo as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-info.7654d0b800130c008ef78b5ce7d7a2d3.svg";